import {createApp} from 'vue/dist/vue.esm-bundler';
import {pinia} from './stores'
import App from './App.vue'
import axios from 'axios'
import router from './router/index'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import './scss/index.scss'
import "bootstrap";
import * as bootstrap from "bootstrap";
// import 'primevue/resources/themes/saga-blue/theme.css'
// import 'primevue/resources/primevue.min.css'
// import 'primeicons/primeicons.css'
import i18n from './i18n'
import { addAPIProvider, Icon } from '@iconify/vue';

addAPIProvider('', {
    resources: ['https://iconify.mmcdn.de'],
});
window.bootstrap = bootstrap
const app = createApp(App)

app.config.globalProperties.$axios = axios;
// app.config.unwrapInjectedRef = true
app.use(i18n)
app.use(router)
app.use(pinia)
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.fixme',
        }
    }
});
app.component('DatePicker', Datepicker)
app.component('DataTable', DataTable)
app.component('TableColumn', Column)
app.component('Icon', Icon)
app.mixin({
    methods: {
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) {
                    map.set(key, [item]);
                } else {
                    collection.push(item);
                }
            });
            return map;
        },
        fetchFromObject(obj, prop) {
            if (typeof obj === 'undefined') {
                return false;
            }

            const _index = prop.indexOf('.')
            if (_index > -1) {
                return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
            }

            return obj[prop];
        },
        formatCentToEuro(cents) {
            if (!Number.isInteger(cents)) {
                return null;
            }
            return (cents / 100).toFixed(2);
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },
        formatDate(dateTime, format) {
            try {
                if (!dateTime) {
                    // return 'invalid date/time'
                    return
                }
                const value = this.$d(dateTime, format)
                if (value === '00:00') {
                    return
                }
                return value
            } catch (e) {
                console.error(e)
            }
            return `failed: ${dateTime}`
        },
    }
})
app.mount('#app')
